import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getStockMovesById = async (moveId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/stock-moves/${moveId}`);
        return await response.data;
    } catch (error) {
        console.log("getStockMovesById - error", error)
        return handleApiError(error)
    }
}

export const searchStockMoves = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-moves/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchStockMovesData - error", error)
        return handleApiError(error)
    }
}

export const insertStockMoves = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-moves/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertStockMoves - error", error)
        return handleApiError(error)
    }
}

export const getStockMovesByDocNos = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-moves/docNos`, data);
        return await response.data;
    } catch (error) {
        console.log("getStockMovesByDocNos - error", error)
        return handleApiError(error)
    }
}

export const getStockVarianceReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-moves/report/variance`, data);
        return await response.data;
    } catch (error) {
        console.log("getStockVarianceReport - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOStockReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-moves/report/buyerpo`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOStockReport - error", error)
        return handleApiError(error)
    }
}

export const getDiscardedStockReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-moves/report/discarded-stock`, data);
        return await response.data;
    } catch (error) {
        console.log("getDiscardedStockReport - error", error)
        return handleApiError(error)
    }
}